import { MenuBar } from "./MenuBar.js";

export interface SidebarOptions {
    container: HTMLElement;
}

export class Sidebar {

    public readonly menu: MenuBar;

    private _element: HTMLElement;

    constructor(options: SidebarOptions) {
        options = e5.object.merge({

        }, options);

        this._element = document.createElement("div");
        this._element.className = "sidebar";
        this._element.innerHTML = `
        <div class="sidebar__content"></div>
        `;

        this.menu = new MenuBar({
            container: this._element.querySelector(".sidebar__content"),
            // direction: "vertical"
        });

        options.container.appendChild(this._element);
    }
}